export const PRODUCCION_GUIA_PRINT_STYLES = `
  .pg-print-doc { font-family: system-ui, -apple-system, 'Segoe UI', sans-serif; color: #1f2937; font-size: 11px; line-height: 1.45; }
  .pg-print-doc h1 { font-size: 18px; font-weight: 700; color: #0f766e; margin: 0 0 4px; text-transform: uppercase; letter-spacing: 0.02em; }
  .pg-print-doc .pg-subtitle { font-size: 12px; color: #4b5563; margin-bottom: 12px; }
  .pg-print-doc .pg-line { border-top: 2px solid #0d9488; margin: 8px 0 14px; }
  .pg-print-doc .pg-meta { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 24px; margin-bottom: 14px; font-size: 11px; }
  .pg-print-doc .pg-meta dt { font-weight: 600; color: #0d9488; display: inline; }
  .pg-print-doc .pg-meta dd { display: inline; margin: 0 0 0 4px; color: #374151; }
  .pg-print-doc .pg-meta-row { margin-bottom: 2px; }
  .pg-print-doc .pg-status { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 10px; font-weight: 600; background: #d1fae5; color: #065f46; border: 1px solid #a7f3d0; }
  .pg-print-doc h2 { font-size: 13px; font-weight: 700; color: #111827; margin: 18px 0 8px; padding-bottom: 4px; border-bottom: 1px solid #e5e7eb; }
  .pg-print-doc table { width: 100%; border-collapse: collapse; margin-bottom: 8px; font-size: 10px; }
  .pg-print-doc th { background: #0d9488; color: #fff; text-align: left; padding: 5px 6px; font-weight: 600; }
  .pg-print-doc th.num, .pg-print-doc td.num { text-align: right; }
  .pg-print-doc td { border: 1px solid #e5e7eb; padding: 4px 6px; vertical-align: top; }
  .pg-print-doc tr:nth-child(even) td { background: #f9fafb; }
  .pg-print-doc .pg-total-box { margin-top: 12px; text-align: right; font-size: 12px; }
  .pg-print-doc .pg-total-box strong { color: #0d9488; }
  .pg-print-doc .pg-notes { margin-top: 14px; padding: 8px; border: 1px solid #e5e7eb; border-radius: 4px; background: #f9fafb; }
  .pg-print-doc .pg-guides-list { margin: 0; padding: 0; list-style: none; }
  .pg-print-doc .pg-guides-list li { margin-bottom: 2px; }
  .pg-print-doc .pg-muted { color: #6b7280; font-size: 10px; }
  .pg-print-doc .pg-page-break { page-break-before: always; }
`;

export const PRODUCCION_GUIA_PRINT_PAGE_STYLES = `
  @media print {
    body { margin: 0; background: #fff; }
    .no-print { display: none !important; }
    .pg-print-page { padding: 0; margin: 0; }
  }
  .pg-print-page { min-height: 100vh; background: #f3f4f6; padding: 16px; }
  .pg-print-toolbar { max-width: 210mm; margin: 0 auto 12px; display: flex; gap: 8px; justify-content: flex-end; }
  .pg-print-sheet { max-width: 210mm; margin: 0 auto; background: #fff; padding: 14mm; box-shadow: 0 1px 3px rgba(0,0,0,.12); }
`;
